export default __webpack_public_path__ + "static/media/(13).dcb99d15.jpg";